// extracted by mini-css-extract-plugin
export default {"loaderWrap":"Loader_loaderWrap__AVuRa","relative":"Loader_relative__GnV-N","loader":"Loader_loader__pvYRd"};